import { LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'

/**
 * Reuses the shared logout handler in AuthContext — same path the chrome
 * sidebar uses. `logout()` POSTs /api/auth/logout, reads `logoutUrl` from the
 * JSON response, and redirects the browser to ZITADEL's end-session endpoint.
 */
export function SignOutSection() {
  const { user, logout } = useAuth()

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        {user
          ? `Signed in as ${user.email}. This ends your session on IntelHub and the identity provider.`
          : 'End your current session.'}
      </p>
      <Button variant="destructive" onClick={() => logout()} className="w-fit">
        <LogOut className="h-4 w-4 mr-2" />
        Sign out
      </Button>
    </div>
  )
}
